import { render, staticRenderFns } from "./LoungeWrite.vue?vue&type=template&id=2bc502ea&scoped=true&"
import script from "./LoungeWrite.vue?vue&type=script&lang=js&"
export * from "./LoungeWrite.vue?vue&type=script&lang=js&"
import style0 from "./LoungeWrite.vue?vue&type=style&index=0&id=2bc502ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc502ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VContainer,VImg,VTextarea})
